import React, { useState, useEffect, useRef } from 'react';
import { Input } from './ui/input';

export const FormattedNumberInput = ({ value, onChange, decimals = 0, className, ...props }) => {
  const [display, setDisplay] = useState('');
  const inputRef = useRef(null);

  const formatWithSeparator = (num) => {
    if (num === null || num === undefined || num === '' || isNaN(num)) return '';
    return new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    }).format(num);
  };

  const parseRaw = (str) => {
    if (!str) return 0;
    // Remove thousands separators (commas in es-MX) and keep decimal point
    const cleaned = str.replace(/,/g, '');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  };

  useEffect(() => {
    // Only update display from prop if input is NOT focused
    if (document.activeElement !== inputRef.current) {
      setDisplay(value ? formatWithSeparator(value) : '');
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value;
    // Allow only digits, commas, dots, and minus
    const filtered = raw.replace(/[^0-9.,-]/g, '');
    
    // Parse and format
    const numValue = parseRaw(filtered);
    
    // Show formatted while typing
    if (filtered === '' || filtered === '-') {
      setDisplay(filtered);
      onChange(0);
    } else {
      setDisplay(formatWithSeparator(numValue));
      onChange(numValue);
    }
  };

  const handleFocus = () => {
    // On focus, show raw number for easier editing
    if (value) {
      setDisplay(value.toString());
    }
  };

  const handleBlur = () => {
    // On blur, show formatted
    setDisplay(value ? formatWithSeparator(value) : '');
  };

  return (
    <Input
      ref={inputRef}
      type="text"
      inputMode="decimal"
      value={display}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={className}
      {...props}
    />
  );
};
